export const textareaPt = () => {
  return {
    root: {
      class: 'font-14-n'
    }
  }
}
